import axiosInstance from './axiosInstance';

const questionService = {
  getQuestions: async (params = {}) => {
    const response = await axiosInstance.get('/questions', { params });
    return response.data;
  },

  getQuestion: async (id) => {
    const response = await axiosInstance.get(`/questions/${id}`);
    return response.data;
  },

  createQuestion: async (data) => {
    const response = await axiosInstance.post('/questions', data);
    return response.data;
  },

  updateQuestion: async (id, data) => {
    const response = await axiosInstance.put(`/questions/${id}`, data);
    return response.data;
  },

  deleteQuestion: async (id) => {
    const response = await axiosInstance.delete(`/questions/${id}`);
    return response.data;
  },

  getQuestionTypes: async () => {
    const response = await axiosInstance.get('/questions/types');
    return response.data;
  },

  createQuestionType: async (data) => {
    const response = await axiosInstance.post('/questions/types', data);
    return response.data;
  },

  updateQuestionType: async (id, data) => {
    const response = await axiosInstance.put(`/questions/types/${id}`, data);
    return response.data;
  },
};

export default questionService; 